import { PoliticalOrg } from '../types/PoliticalOrg';

export function getOrgDisplayNameFromOrg(org: PoliticalOrg | null): string {
  return org?.name || 'Unknown Organization';
}

export function getOrgLogoFromOrg(org: PoliticalOrg | null): string {
  return org?.logo || '/assets/images/default-org-logo.png';
}
